module.exports = __webpack_public_path__ + "img/tongyong.fa184434.png";